import { makeStyles, Theme } from '@material-ui/core'
import { StatusSize } from './Type'

export const useStyle = makeStyles<Theme, { wrapText: boolean; size: StatusSize }>(() => {
  const statusLarge = {
    padding: '8px 9px',
  }
  const statusSmall = {
    padding: '3px 7px',
  }
  const textLarge = {
    fontSize: 14,
  }
  const textSmall = {
    fontSize: 12,
  }

  return {
    status: (props) => ({
      padding: '4px 7px',
      borderRadius: 4,
      background: 'red',
      display: 'flex',
      justifyContent: 'center',
      maxWidth: '200px',
      textAlign: props.wrapText ? 'left' : 'center',
      ...(props.size === 'large' ? statusLarge : {}),
      ...(props.size === 'small' ? statusSmall : {}),
    }),
    text: (props) => ({
      borderRadius: 5,
      color: '#FFF',
      fontSize: props.size === 'medium' ? 12 : 14,
      fontWeight: 500,
      lineHeight: '24px',
      ...(props.size === 'large' ? textLarge : {}),
      ...(props.size === 'small' ? textSmall : {}),
    }),
  }
})
